import React, { useRef } from 'react';
import { useAsyncValue, Link, useNavigation, useLocation } from 'react-router-dom';
import { CMAddressBook, GetCampaignsResponseItem } from 'services/apiService';
import { useState, useMemo, useCallback, useEffect } from 'react';
import { DataGrid, GridColDef, GridRenderCellParams, GridToolbar } from '@mui/x-data-grid';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ScheduleCampaingForm from 'views/address-books/ScheduleCampaingForm';
import { Button, IconButton, } from '@mui/material';
import AppNavigation from 'router/AppNavigation';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ContactsIcon from "@mui/icons-material/Contacts";
import SendIcon from "@mui/icons-material/Send";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import Tooltip from "@mui/material/Tooltip";
import { format } from "date-fns";

import { useFetcher } from 'react-router-dom';
import CampaignDeleteDialog from './CampaignDeleteDialog';
import { HomeAction } from 'views/home/Home';
import { useSnackbar } from "notistack";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import RateReviewIcon from '@mui/icons-material/RateReview';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import MarkChatReadIcon from '@mui/icons-material/MarkChatRead';
import { ca } from 'date-fns/locale';

const BACKUPDATAGRID = ({ cm_status }: { cm_status: string }) => {
    // Get loader data
    const [results, addressBooks] = useAsyncValue() as [GetCampaignsResponseItem[], CMAddressBook[]];


    console.log("\t # ✅ here is the result data :", results)

    const [campaigns, setCampaigns] = useState(results)
    const [pageSize, setPageSize] = useState(10);
    console.log("cm_status ===========================>: ", cm_status)


    // ================================ CAMPAIGN SENT STATUS ================================
    const sentCampaigns = useMemo(() => {
        return campaigns.filter(
            (campaign) => campaign.cm_status === 'sent'
        );
    }, [campaigns]);

    // ================================ CAMPAIGN SCHEDULED STATUS ================================
    const shceduledCampaigns = useMemo(() => {
        return campaigns.filter(
            (campaign) => campaign.cm_status === 'scheduled'
        );
    }, [campaigns]);

    // ================================ CAMPAIGN DRAFT STATUS ================================
    const draftCampaigns = useMemo(() => {
        return campaigns.filter(
            (campaign) => campaign.cm_status === 'draft'
        );
    }, [campaigns]);

    useEffect(() => {
        switch (cm_status) {
            case "draft":
                console.log("******************* ato am campagne draft ***************")
                setCampaigns(draftCampaigns)
                break;

            case "scheduled":
                console.log("********************** ato am campagne scheduled ***************************")
                setCampaigns(shceduledCampaigns)
                break;

            case "sent":
                console.log("************************  ato am sent *****************************")
                setCampaigns(sentCampaigns)
                break;

            default:
                setCampaigns(campaigns);
                break;
        }
    }, [])

    console.log("SENT CAMAPIGNS :", sentCampaigns);
    const RowActions = ({id, sender, schedule_date, campaignCmId, cm_group_id, onDelete}: {id: number; sender: string; schedule_date: any; campaignCmId: string; cm_group_id: string; onDelete: (id: number) => void}) => {
        const fetcher = useFetcher();
        const { enqueueSnackbar } = useSnackbar();

        // Contact create form dialog handles
        const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
        const onCreateDialogClose = useCallback(() => {setIsCreateDialogOpen(false);}, [setIsCreateDialogOpen]);

        const [isDeleteCampaignDialog, setIsDeleteCampaignDialog] = useState(false);
        const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
        const open = Boolean(anchorEl);
        const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {setAnchorEl(event.currentTarget);};
        const handleClose = () => {setAnchorEl(null);};

        const handleOpenDeleteCampaignDialog = () => {setIsDeleteCampaignDialog(true);};

        const handleCloseDeleteCampaignDialogClose = () => {setIsDeleteCampaignDialog(false);};

        React.useEffect(() => {
            if (fetcher.data) {
                console.log("fetcher.data : ", fetcher.data)
                if (fetcher.data.success) {
                    switch (fetcher.data.action) {
                        case HomeAction.DeleteCampaing:
                            console.log("fetcher success")
                            enqueueSnackbar("Campagne supprimée avec succès!", {
                                variant: "success",
                            });
                            handleCloseDeleteCampaignDialogClose();
                            break;
                        default:
                            break;
                    }

                } else {
                    console.log("fetcher error")
                    enqueueSnackbar(fetcher.data.error, { variant: "error" });
                }
            }
        }, [fetcher.data, enqueueSnackbar]);


        // ============================== Generate Menu closed action =============================
        const menuRef = useRef<HTMLDivElement | null>(null);
        const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);

        useEffect(() => {
            if (!open) return;

            const handleMouseMove = (event: MouseEvent) => {
                if (menuRef.current) {
                    const { left, right, top, bottom } = menuRef.current.getBoundingClientRect();
                    const { clientX, clientY } = event;

                    // Vérifier si la souris est en dehors du menu
                    if (clientX < left || clientX > right || clientY < top || clientY > bottom) {
                        const timeout = setTimeout(() => {
                            handleClose();
                        }, 200); // Petit délai pour éviter la fermeture trop brusque
                        setTimeoutId(timeout);
                    } else {
                        if (timeoutId) clearTimeout(timeoutId);
                    }
                }
            };

            document.addEventListener("mousemove", handleMouseMove);

            return () => {
                document.removeEventListener("mousemove", handleMouseMove);
                if (timeoutId) clearTimeout(timeoutId);
            };
        }, [open, timeoutId]);


        // ========================== Popup to confirm dialog = =========================
        // return (
        //     <div
        //         style={{
        //             display: "flex",
        //             flexDirection: "row",
        //             justifyContent: "center",
        //         }}
        //     >
        //         <Tooltip title="">
        //             <IconButton aria-label="more" onClick={handleClick}>
        //                 <MoreHorizIcon fontSize="inherit" />
        //             </IconButton>
        //         </Tooltip>

        //         <Menu anchorEl={anchorEl} open={open} onClose={handleClose}
        //             PaperProps={{
        //                 ref: menuRef,
        //                 style: { padding: "10px", border: "1px solid #ddd" },
        //             }}
        //         >
        //             <MenuItem>
        //                 <ListItemIcon>
        //                     <Button
        //                         aria-label="address-book"
        //                         component={Link}
        //                         to={AppNavigation.CampaignAddressBook.replace(
        //                             ":campaignId",
        //                             id.toString()
        //                         )}
        //                         color="primary"
        //                         title='Address Book'
        //                         size='small'
        //                         startIcon={<ContactsIcon />}
        //                     >
        //                         Address Book
        //                     </Button >
        //                 </ListItemIcon>
        //             </MenuItem>
        //             <MenuItem>
        //                 <ListItemIcon>
        //                     <Button
        //                         aria-label="send-test"
        //                         component={Link}
        //                         to={AppNavigation.CampaignSendTest.replace(
        //                             ":campaignId",
        //                             id.toString()
        //                         )}
        //                         color="success"
        //                         size='small'
        //                         startIcon={<SendIcon />}
        //                     >
        //                         Send test
        //                     </Button >
        //                 </ListItemIcon>
        //             </MenuItem>

        //             {/* ================================ DRAFT CAMPAIGN ACTION DISPO ================================= */}
        //             {cm_status === "draft" && 
        //             <MenuItem>
        //                 <ListItemIcon>
        //                     <Button
        //                         aria-label="schedule-campaing"
        //                         onClick={() => setIsCreateDialogOpen(true)}
        //                         color="secondary"
        //                         size='small'
        //                         startIcon={<AccessTimeIcon />}
        //                     >
        //                         Schedule
        //                     </Button >
        //                 </ListItemIcon>
        //             </MenuItem>}

        //             {cm_status === "scheduled" && <MenuItem>
        //                 <fetcher.Form method="put">
        //                     <input type="string" name="campaignId" value={campaignCmId} hidden readOnly />
        //                     <ListItemIcon>
        //                         <Button
        //                             aria-label="cancel-campaing"
        //                             type="submit"
        //                             size='small'
        //                             startIcon={<StopCircleIcon />}
        //                         >
        //                             Cancel
        //                         </Button >
        //                     </ListItemIcon>
        //                 </fetcher.Form>
        //             </MenuItem>}

        //             {cm_status === "draft" && 
        //             <MenuItem>
        //                 <ListItemIcon>
        //                     <Button
        //                         aria-label="edit"
        //                         component={Link}
        //                         to={AppNavigation.EditCampaign.replace(":campaignId", id.toString())}
        //                         state={{ 'previous': 'edit' }}
        //                         color="info"
        //                         size='small'
        //                         startIcon={<EditIcon />}
        //                     >
        //                         Edit
        //                     </Button >
        //                 </ListItemIcon>
        //             </MenuItem>}

        //             <MenuItem>
        //                 <ListItemIcon>
        //                     <Link
        //                         aria-label="edit"
        //                         to={AppNavigation.CloneCampaign.replace(":campaignId", id.toString())}
        //                         state={{ 'previous': 'clone' }}
        //                     >
        //                         <Button
        //                             color="warning"
        //                             size='small'
        //                             startIcon={<CopyAllIcon />}
        //                         >
        //                             Clone
        //                         </Button>
        //                     </Link>
        //                 </ListItemIcon>
        //             </MenuItem>
        //             <MenuItem>
        //                 <ListItemIcon>
        //                     <Button
        //                         aria-label="delete-campaign"
        //                         onClick={() => setIsDeleteCampaignDialog(true)}
        //                         color="error"
        //                         size='small'
        //                         startIcon={<DeleteIcon />}
        //                     >
        //                         Delete
        //                     </Button >
        //                 </ListItemIcon>
        //             </MenuItem>
        //         </Menu>


        //         <ScheduleCampaingForm
        //             open={isCreateDialogOpen}
        //             onClose={onCreateDialogClose}
        //             fetcher={fetcher}
        //             addressBooks={addressBooks}
        //             campaignId={id}
        //             sender={sender}
        //             schedule_date={schedule_date}
        //             campaignCmId={campaignCmId}
        //             cm_group_id={cm_group_id}
        //         />
        //         <CampaignDeleteDialog
        //             open={isDeleteCampaignDialog}
        //             handleClose={handleCloseDeleteCampaignDialogClose}
        //             fetcher={fetcher}
        //             handleOpen={handleOpenDeleteCampaignDialog}
        //             campaignId={id}
        //             campaignCmId={campaignCmId}
        //         />
        //     </div>
        // );
        return (
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                <Tooltip title="">
                    <IconButton aria-label="more" onClick={handleClick}>
                        <MoreHorizIcon fontSize="inherit" />
                    </IconButton>
                </Tooltip>

                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    PaperProps={{ ref: menuRef, style: { padding: "10px", border: "1px solid #ddd" } }}
                >
                    {/* Address Book - Disponible pour tous les statuts */}
                    <MenuItem>
                        <ListItemIcon>
                            <Button
                                aria-label="address-book"
                                component={Link}
                                to={AppNavigation.CampaignAddressBook.replace(":campaignId", id.toString())}
                                color="primary"
                                title="Address Book"
                                size="small"
                                startIcon={<ContactsIcon />}
                            >
                                Address Book
                            </Button>
                        </ListItemIcon>
                    </MenuItem>

                    {/* Send Test - Disponible pour tous les statuts */}
                    <MenuItem>
                        <ListItemIcon>
                            <Button
                                aria-label="send-test"
                                component={Link}
                                to={AppNavigation.CampaignSendTest.replace(":campaignId", id.toString())}
                                color="success"
                                size="small"
                                startIcon={<SendIcon />}
                            >
                                Send test
                            </Button>
                        </ListItemIcon>
                    </MenuItem>

                    {/* Options disponibles uniquement si le statut est "draft" */}
                    {cm_status === "draft" && (
                        <>
                            <MenuItem>
                                <ListItemIcon>
                                    <Button
                                        aria-label="schedule-campaign"
                                        onClick={() => setIsCreateDialogOpen(true)}
                                        color="secondary"
                                        size="small"
                                        startIcon={<AccessTimeIcon />}
                                    >
                                        Schedule
                                    </Button>
                                </ListItemIcon>
                            </MenuItem>

                            <MenuItem>
                                <ListItemIcon>
                                    <Button
                                        aria-label="edit"
                                        component={Link}
                                        to={AppNavigation.EditCampaign.replace(":campaignId", id.toString())}
                                        state={{ previous: "edit" }}
                                        color="info"
                                        size="small"
                                        startIcon={<EditIcon />}
                                    >
                                        Edit
                                    </Button>
                                </ListItemIcon>
                            </MenuItem>
                        </>
                    )}

                    {/* Clone disponible pour "draft" et "sent" */}
                    {cm_status === "draft" || cm_status === "sent" ? (
                        <MenuItem>
                            <ListItemIcon>
                                <Link
                                    aria-label="clone"
                                    to={AppNavigation.CloneCampaign.replace(":campaignId", id.toString())}
                                    state={{ previous: "clone" }}
                                >
                                    <Button color="warning" size="small" startIcon={<CopyAllIcon />}>
                                        Clone
                                    </Button>
                                </Link>
                            </ListItemIcon>
                        </MenuItem>
                    ) : null}

                    {/* Cancel disponible uniquement si "scheduled" */}
                    {cm_status === "scheduled" && (
                        <MenuItem>
                            <fetcher.Form method="put">
                                <input type="hidden" name="campaignId" value={campaignCmId} readOnly />
                                <ListItemIcon>
                                    <Button
                                        aria-label="cancel-campaign"
                                        type="submit"
                                        size="small"
                                        startIcon={<StopCircleIcon />}
                                    >
                                        Cancel
                                    </Button>
                                </ListItemIcon>
                            </fetcher.Form>
                        </MenuItem>
                    )}

                    {/* Delete disponible pour "draft" et "sent" */}
                    {(cm_status === "draft" || cm_status === "sent") && (
                        <MenuItem>
                            <ListItemIcon>
                                <Button
                                    aria-label="delete-campaign"
                                    onClick={() => setIsDeleteCampaignDialog(true)}
                                    color="error"
                                    size="small"
                                    startIcon={<DeleteIcon />}
                                >
                                    Delete
                                </Button>
                            </ListItemIcon>
                        </MenuItem>
                    )}
                </Menu>

                {/* Modales */}
                <ScheduleCampaingForm
                    open={isCreateDialogOpen}
                    onClose={onCreateDialogClose}
                    fetcher={fetcher}
                    addressBooks={addressBooks}
                    campaignId={id}
                    sender={sender}
                    schedule_date={schedule_date}
                    campaignCmId={campaignCmId}
                    cm_group_id={cm_group_id}
                />
                <CampaignDeleteDialog
                    open={isDeleteCampaignDialog}
                    handleClose={handleCloseDeleteCampaignDialogClose}
                    fetcher={fetcher}
                    handleOpen={handleOpenDeleteCampaignDialog}
                    campaignId={id}
                    campaignCmId={campaignCmId}
                />
            </div>
        );

    };

    const createColumns = ({onCampaignDelete,}: {onCampaignDelete: (id: number) => void;}): GridColDef[] => {
        return [
            {
                field: "",
                headerName: "",
                width: 50,
                renderCell: (params: GridRenderCellParams<string>) =>
                    params.row.cm_status === 'draft'
                        ? <RateReviewIcon style={{ color: "#3498DB" }} titleAccess="draft" /> :
                        params.row.cm_status === 'scheduled' ? <WatchLaterIcon style={{ color: "#FFC300" }} titleAccess="scheduled" /> :
                            <MarkChatReadIcon style={{ color: "#2ECC71" }} titleAccess="sent" />,
            },
            {
                field: "id",
                headerName: "ID",
                width: 90
            },
            {
                field: "create_date",
                headerName: "Date de création",
                width: 140,
                // hide: true,
                renderCell: (params: GridRenderCellParams<string>) =>
                    params.value
                        ? format(new Date(params.value), "dd/MM/yyyy")
                        : "Invalid date format",
            },
            {
                field: "stats_scheduled_date",
                headerName: "Date de programmation",
                width: 170,
                renderCell: (params: GridRenderCellParams<string>) =>
                    params.value
                        ? format(new Date(params.value), `dd/MM/yyyy ${params.value.substring(11, 13)}:${params.value.substring(14, 16)}`)
                        : "Invalid date format"
            },
            {
                field: "stats_base_name",
                headerName: "Base",
                width: 200,
                hide: (cm_status === "sent") ? true : false
            },
            {
                field: "stats_tags_name",
                headerName: "Tag",
                width: 130,
                hide: (cm_status === "sent") ? true : false
            },
            {
                field: "name",
                headerName: "Campagne",
                minWidth: (cm_status === "sent") ? 200 : 620,
                flex: 1,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.value} placement="top">
                            <div>{params.value}</div>
                        </Tooltip>
                    );
                },
            },
            {
                field: "cm_sender",
                headerName: "Sender",
                width: 100,
                hide: true,
            },
            {
                field: "cm_group_id",
                headerName: "Cm addressBook id",
                width: 200,
                hide: true
            },
            {
                field: "cm_id",
                headerName: "Cm id",
                width: 200,
                hide: true
            },
            {
                field: "cm_recipients",
                headerName: "Volume",
                width: 100,
                hide: (cm_status === "sent") ? false : true
            },
            {
                field: "cm_messages",
                headerName: "Messages",
                width: 100,
                hide: (cm_status === "sent") ? false : true
            },
            {
                field: "cm_delivered",
                headerName: "Delivered",
                width: 100,
                hide: (cm_status === "sent") ? false : true
            },
            {
                field: "cm_optout",
                headerName: "Optout",
                width: 100,
                hide: (cm_status === "sent") ? false : true
            },
            {
                field: "cm_converted",
                headerName: "Converted",
                width: 100,
                hide: (cm_status === "sent") ? false : true
            },
            {
                field: "cm_failed",
                headerName: "Failed",
                width: 100,
                hide: (cm_status === "sent") ? false : true
            },
            {
                field: "cm_price",
                headerName: "Price",
                width: 100,
                hide: (cm_status === "sent") ? false : true
            },
            {
                field: "actions",
                headerName: "Actions",
                width: 100,
                valueGetter: (params) => params.row.id,
                renderCell: (params: GridRenderCellParams<number>) =>
                    params.value ? (
                        <RowActions id={params.value} sender={params.row.cm_sender} schedule_date={params.row.stats_scheduled_date} campaignCmId={params.row.cm_id} cm_group_id={params.row.cm_group_id} onDelete={onCampaignDelete} />
                    ) : (
                        "No actions available"
                    ),
            },
        ];
    };

    const [toDeleteCampaignName, setToDeleteCampaignName] = useState("");

    const navigation = useNavigation();

    const onCampaignDelete = useCallback((id: number) => {
        setToDeleteCampaignName(
            campaigns.find((campaign) => campaign.id === id)?.name || ""
        );
    },
        [campaigns]
    );

    const columns = useMemo(() => {
        return createColumns({ onCampaignDelete });
    }, [onCampaignDelete]);

    return (
        <div style={{ display: "flex", height: "90%" }}>
            <div style={{ flexGrow: 1 }}>
                <DataGrid columns={columns} rows={campaigns} components={{ Toolbar: GridToolbar }}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                />
            </div>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={navigation.state === "submitting"}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress color="inherit" />
                    {toDeleteCampaignName && (
                        <p>Deleting campaign "{toDeleteCampaignName}"...</p>
                    )}
                </div>
            </Backdrop>

        </div>
    );
};

export default BACKUPDATAGRID;